module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-2.svg?7d690769b9cabdc077d69ddd47fb5082";